import { useParams } from 'react-router-dom'
import { amenities, properties, propertyImages } from '../data'
import "./Property.css"
import { LuBedDouble } from 'react-icons/lu'
import { PiBathtub } from 'react-icons/pi'
import { BiArea } from 'react-icons/bi'
import subimage1 from '../assets/Shop1-M.png'
import room1 from '../assets/IMG-20250222-WA0029.jpg'
import room2 from '../assets/IMG-20250222-WA0030.jpg'
import room3 from '../assets/IMG-20250222-WA0044.jpg'
import Ccard from './Ccard'

const Property = () => {

    const {id}  = useParams()
    const numericId = Number(id);
  // const property = properties.find((property) => property.id === parseInt(id))
    const property =properties.filter((property) => property.id === numericId)[0];
    
  return (
    <div>
      
      <div className='property-container'>
        <div className='property-wrapper'>
            <h1 className='property-heading'>
                {property.type} for {property.title} in {property.address}
            </h1>
            <div className='property-images'>
                <div className='main-image'>
                     <img src={property.image} alt='' /> 
                    
                </div>
               {/*} <div className='small-images'>
                
                    {propertyImages.slice(1).map((image, index) => (
                        <img src={image.image} key={index}  alt=''/>

                    ))}
                </div>
               */ }
               <div className='small-images'>
  {property.id === 3 && (
    <>
      <img src={room1} alt='Property 3 - Image 1' className='small-img' />
      <img src={room2} alt='Property 3 - Image 1' className='small-img' />
      <img src={room3} alt='Property 3 - Image 1' className='small-img' />
    </>
  )}

  {property.id === 1 && (
    <>
      <img src= {subimage1} alt='Property 5 - Image 1' className='small-img' />
    </>
  )}
  <Ccard/>
</div>

            </div>

            <div className='property-details'>
                <h1>{property.price}</h1>
                <div className='property-rooms'>
                    <span>
                        <LuBedDouble className='icon'  />
                        <p>{property.bedrooms} Bedrooms </p> 
                    </span>
                    <span>
                        <PiBathtub className='icon' />
                        {property.bathrooms} Bathrooms
                    </span>
                    <span>
                        <BiArea className="icon"/>
                        <p>{property.size} (sqm)</p>
                    </span>
                </div>
            </div>
            {property.id === 1 && (
            <div className='property-amenities'>
                <h1>Amenities</h1>
                <div className='amenities'>
                    {amenities.map((item)=>(
                        <div key={item.id} className='amenity'>
                            <span className='icon'>{item.iocn}</span>
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        )}
        </div>
      </div>
      </div>
  )
}

export default Property



